import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="w-full bg-foreground-900 text-background-50">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="sm:col-span-2 lg:col-span-2">
            <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-file-list-3-line text-lg text-background-50"></i>
              </div>
              <span className="font-heading text-xl text-background-50">
                Hipobuy Sheet
              </span>
            </Link>
            <p className="text-sm text-foreground-300 leading-relaxed max-w-sm mb-5">
              An independent educational resource dedicated to helping shoppers discover, compare, and make smarter purchasing decisions through spreadsheet-based shopping guides.
            </p>
            <div className="flex items-center gap-3">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-4 py-2 rounded-md bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-shopping-cart-line"></i>
                Hipobuy Sheet
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-4 py-2 rounded-md border border-foreground-400 text-foreground-300 text-sm font-medium hover:bg-foreground-800 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer"
              >
                Buy It Now
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50 mb-4">Quick Links</h4>
            <ul className="space-y-2.5">
              <li>
                <a href="#categories" className="text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer">
                  Browse Categories
                </a>
              </li>
              <li>
                <a href="#about" className="text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer">
                  What Is Hipobuy Spreadsheet
                </a>
              </li>
              <li>
                <a href="#compare" className="text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer">
                  Platform Comparison
                </a>
              </li>
              <li>
                <Link to="/hipobuy-spreadsheet-guide" className="text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer">
                  Complete Guide
                </Link>
              </li>
              <li>
                <Link to="/hipobuy-spreadsheet-beginners" className="text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer">
                  Beginners Guide
                </Link>
              </li>
              <li>
                <Link to="/hipobuy-spreadsheet-safety" className="text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer">
                  Safety Tips
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50 mb-4">Top Categories</h4>
            <ul className="space-y-2.5">
              <li>
                <a href="https://kaspreadsheet.com/category-911-Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer">
                  Shoes
                </a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com/search-912/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer">
                  Hoodies &amp; Sweaters
                </a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com/search-913/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer">
                  T-Shirts
                </a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com/search-914/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer">
                  Jackets
                </a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com/search-920/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer">
                  Accessories
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-foreground-700/40 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} Hipobuy Sheet. All rights reserved. This is an independent resource — not affiliated with any marketplace.
          </p>
          <div className="flex items-center gap-5">
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-foreground-400 hover:text-background-50 transition-colors cursor-pointer">
              Main Store
            </a>
            <Link to="/hipobuy-spreadsheet-guide" className="text-xs text-foreground-400 hover:text-background-50 transition-colors cursor-pointer">
              SEO Guide
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}